import React, { useRef } from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { useReportContext } from 'contexts/ReportContext';
import { Field } from 'helpers/CalendarImports';
import { Report, ReportData } from 'models/ReportModel';
import { ReportFilter, OptionMore } from 'models/BaseModel';
import { ReportColumn, ReportChart } from 'models/BaseModel';
import ChartDesigner from "components/common/ChartDesigner";


const ReportCustom: React.FC = () => {
  const width = { doctor: 20, location: 15, date: 15, start: 10, end: 10, comment:24 }
  const [formId, formName] = [Code.Form.Id.REPORT, Code.Form.Name.REPORT];
  const { loading, setLoading, error, setError, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, menuPosition, setMenuPosition, iframeRef, contextMenuRef  } = useReportContext();
  const Privilege = Hooks.Privilege.List(Code.Form.Id.REPORTS);
  const PriReport = Hooks.Privilege.Report();
  const [reportOptions, setReportOptions] = Hooks.Form.OptionMore();
  const [reportList, setReportList] = Hooks.Form.OptionMore();
  const [sessionOptions, setSessionOptions] = Hooks.Form.Options();
  const [reportData, setReportData] = useState<ReportData[]>([]);
  const [reportFilter, setReportFilter] = useState<ReportFilter>({});
  const [reportId, setReportId] = useState<number | null>(0); 
  const [sessionId, setSessionId] = useState<number | null>(Code.Option.Session.TODAY);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [dateVisible, setDateVisible] = useState<boolean>(false);
  const [paramInfo, setParamInfo] = Hooks.Form.OptionMore();
  const [reportTable, setReportTable] = useState<number>(0);
 
  const [showReport, setShowReport] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [showlayout, setShowLayout] = useState<boolean>(false);
  
  const [locationOptions, setLocationOptions] = Hooks.Form.Options();
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [selectedDoctor, setSelectedDoctor] = useState<string[]>([]);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [examTypeOptions, setExamTypeOptions] = Hooks.Form.Options();
  const [mopOptions, setMopOptions] = Hooks.Form.Options();
  const [chartOptions, setChartOptions] = Hooks.Form.Options();
  const [orientationOptions, setOrientationOptions] = Hooks.Form.Options();
  const [viewOptions, setViewOptions] = Hooks.Form.Options();
  
  const [selectedLocation, setSelectedLocation] = useState<string[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<string[]>([]);
  const [selectedSegment, setSelectedSegment] = useState<string[]>([]);
  const [selectedUser, setSelectedUser] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const [selectedType, setSelectedType] = useState<string[]>([]);
  const [selectedExamType, setSelectedExamType] = useState<string[]>([]);
  const [selectedMop, setSelectedMop] = useState<string[]>([]);
  const [selectedChart, setSelectedChart] = useState<number>(Code.Chart.Type.NONE);
  const [selectedOrientation, setSelectedOrientation] = useState<number | undefined>(Code.Option.Oriantation.PORTRAIT);
  const [selectedView, setSelectedView] = useState<number>(Code.Option.DataView.GROUP);
  
  const [chartData, setChartData] = useState<any>();
  const [chartOption, setChartOption] = useState<any>();
  
  const [reportColumnData, setReportColumnData] = useState<ReportColumn[]>([]);
  const [reportChartData, setReportChartData] = useState<ReportChart>({});
  const [formData, setFormData] = useState<Report>({});
  

  //show/hide filters as per selected report
  const companyName = Utility.Storage.CompanyName();
  const locationMap: number[] = [0, 
    Code.Form.Id.PAYMENT, Code.Form.Id.INVOICE, Code.Form.Id.APPOINTMENT, Code.Form.Id.BILLING, Code.Form.Id.DAYBOOK, Code.Form.Id.EXAM, 
    Code.Form.Id.PROJECT, Code.Form.Id.ITEM, Code.Form.Id.INVENTORY, Code.Form.Id.RECALL, Code.Form.Id.SCHEDULE  
  ] 
  const branchMap: number[] = [0, Code.Form.Id.SCHEDULE] 
  const segmentMap: number[] = [0, Code.Form.Id.PAYMENT, Code.Form.Id.INVOICE] 
  const doctorMap: number[] = [0, Code.Form.Id.SCHEDULE, Code.Form.Id.INVOICE, Code.Form.Id.APPOINTMENT, Code.Form.Id.BILLING, Code.Form.Id.EXAM ] 
  const userMap: number[] = [0, Code.Form.Id.PAYMENT, Code.Form.Id.INVOICE] 
  const statusMap: number[] = [] 
  const typeMap: number[] = [] 
  const examTypeMap: number[] = [0, Code.Form.Id.EXAM] 
  const mopMap: number[] = [0, Code.Form.Id.PAYMENT] 
  
  Hooks.Privilege.HasView(Privilege);
  const printRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    Files.Json.APIMore(Code.Form.Name.REPORT, Code.Option.Common.SELECT, setReportOptions, setError);
    Files.Json.Http(Code.Form.Name.SESSION, Code.Option.Common.NOTHING, setSessionOptions, setError);
    Files.Json.API(Code.File.LOCATION, Code.Option.Common.NOTHING, setLocationOptions, setError);
    Files.Json.API(Code.File.SEGMENT, Code.Option.Common.NOTHING, setSegmentOptions, setError);
    Files.Json.API(Code.File.DOCTOR, Code.Option.Common.NOTHING, setDoctorOptions, setError);
    Files.Json.API(Code.File.USER, Code.Option.Common.NOTHING, setUserOptions, setError);
    Files.Json.API(Code.File.STATUS, Code.Option.Common.NOTHING, setStatusOptions, setError);
    Files.Json.API(Code.File.TYPE, Code.Option.Common.NOTHING, setTypeOptions, setError);
    Files.Json.API(Code.File.MOP, Code.Option.Common.NOTHING, setMopOptions, setError);
    Files.Json.API(Code.File.EXAMTYPE, Code.Option.Common.SELECT, setExamTypeOptions, setError);
    Files.Json.Http(Code.File.CHART+Code.File.TYPE, Code.Option.Common.NONE, setChartOptions, setError);
    Files.Json.Http(Code.File.ORIENTATION, Code.Option.Common.NOTHING, setOrientationOptions, setError);
    Files.Json.Http(Code.File.DATA+Code.File.VIEW, Code.Option.Common.NOTHING, setViewOptions, setError);
   
    //console.log("PriReport:",PriReport);

  }, []);

  useEffect(() => {
    //console.log("PriReport:",PriReport);
    if(!PriReport.includes("#")) setReportList([]);
    else if(PriReport.includes("#00000#")) setReportList(reportOptions);
    else{
      const result = PriReport.split("#").filter(Boolean).map(Number).concat(0);
      const filterList = reportOptions.filter(option => result.includes(option.value));
      setReportList(filterList);
    }
      
    
  }, [reportOptions]);

  const callReportData = useCallback(async (companyId: number, reportId: number, startDate: string, endDate: string, reportFilter: ReportFilter ) => {
    const url = API.Build.ReportApiEndpint(companyId, reportId, startDate, endDate, reportFilter);
    await API.Data.List<ReportData>(url, setReportData, setError, setLoading); 
    //console.log("report url:",url);
  
    API.Data.GetByKeyId<Report>(formName, reportId.toString(), setLoading, setError)
      .then(async(data) => { if(data) {
        Files.List.parseJsonDataObject(data.report_column_data, setReportColumnData);
        Files.List.parseJsonData(data.report_chart_data, setReportChartData);
        console.log("Report Orientation:",data.report_orientation);
        setSelectedOrientation(data.report_orientation);
        // if(selectedOrientation != Code.Option.Oriantation.PORTRAIT) {
        //   setSelectedOrientation(data.report_orientation);
        // }
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }}) 
    
  },[]);

  useEffect(() => {
    //console.log("startDate:",startDate);
  }, [startDate]);

  useEffect(() => {
    //console.log("endDate:",endDate);
  }, [endDate]);

  useEffect(() => {
    //console.log("selectedLocation:",selectedLocation);
  }, [selectedLocation]);
  
  useEffect(() => {
    //console.log("chartData:",chartData);
  }, [chartData]);

   useEffect(() => {
    //console.log("chartOption:",chartOption);
  }, [chartOption]);

  useEffect(() => {
    getChartData();
  }, [reportData, reportColumnData, selectedView]);

  // useEffect(() => {
  //   if(reportData){
  //     console.log("reportData:", reportData);
  //   }
  // }, [reportData]);

  // useEffect(() => {
  //   if(reportColumnData){
  //     console.log("reportColumnData:",reportColumnData);
  //   }
  // }, [reportColumnData]);

  useEffect(() => {
    //console.log("reportFilter:",reportFilter);
  }, [reportFilter]);

  useEffect(() => {
    //console.log("reportId:",reportId);
    if (reportId) {
        const selectedOption = reportOptions.find(option => option.value === reportId);
        setReportTable(selectedOption?.data1 ? Number(selectedOption?.data1) : 0)
        setReportFilter({});
        onClearFilter();
    }
  }, [reportId]);

  useEffect(() => {
    const localLocation = Utility.Storage.LocationId();
    if(localLocation) {
      if(locationMap.includes(reportTable))  { 
        setSelectedLocation([localLocation.toString()]); 
        setSelectedBranch([]); 
      } else if(branchMap.includes(reportTable)) { 
        setSelectedBranch([localLocation.toString()]); 
        setSelectedLocation([]);
      }
    }
  }, [reportTable]);

  useEffect(() => {
    //console.log("paramInfo:",paramInfo);
  }, [paramInfo]);

  useEffect(() => {
    //console.log("reportColumnData:",reportColumnData);
  }, [reportColumnData]);

  useEffect(() => {
    //console.log("reportOptions:",reportOptions);
  }, [reportOptions]);

  useEffect(() => {
    //console.log("selectedLocation:",selectedLocation);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Location.Id, selectedLocation.toString())
    );
  }, [selectedLocation]);

  useEffect(() => {
    //console.log("selectedBranch:",selectedBranch);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Common.BranchId, selectedBranch.toString())
    );
  }, [selectedBranch]);

  useEffect(() => {
    //console.log("selectedSegment:",selectedSegment);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Common.SegmentId, selectedSegment.toString())
    );
  }, [selectedSegment]);

  useEffect(() => {
    //console.log("selectedDoctor:",selectedDoctor);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Doctor.Id, selectedDoctor.toString())
    );
  }, [selectedDoctor]);

  useEffect(() => {
    //console.log("selectedUser:",selectedUser);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.User.Id, selectedUser.toString())
    );
  }, [selectedUser]);

  useEffect(() => {
    //console.log("selectedStatus:",selectedStatus);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Common.StatusId, selectedStatus.toString())
    );
  }, [selectedStatus]);

  useEffect(() => {
    //console.log("selectedType:",selectedType);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Common.TypeId, selectedType.toString())
    );
  }, [selectedType]);

  useEffect(() => {
    //console.log("selectedExamType:",selectedExamType);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.ExamType.Id, selectedExamType.toString())
    );
  }, [selectedExamType]);

  useEffect(() => {
    //console.log("selectedMop:",selectedMop);
    setReportFilter(prev =>
      updateReportFilter(prev, Name.Common.ModeId, selectedMop.toString())
    );
  }, [selectedMop]);

  useEffect(() => {
    setDateVisible(sessionId == Code.Option.Session.CUSTOM);

    const range = Utility.Get.DateRange(sessionId);
    if (range) {
      setStartDate(Utility.Format.Date(range.startDate,Code.Format.DateTime.Date));
      setEndDate(Utility.Format.Date(range.endDate,Code.Format.DateTime.Date));
    }
  }, [sessionId]);

  const onShowReport = () => {
    //console.log("Show Reports:",reportId,sessionId);
    if(reportId==Code.Option.Common.SELECT) {
      Utility.Message.Warning(["Select any report"],setMessage);
      return;
    }
    const companyId = Utility.Storage.CompanyId();
    if(reportFilter && companyId && reportId &&  reportId>0 && startDate && endDate){
      callReportData(companyId, reportId, startDate, endDate, reportFilter);
    }
    getPatamInfo();
    setShowReport(true);
    
  };

  const getPatamInfo = () => {
    
    const newParams: OptionMore[] = [];
    const segments = document.getElementById("segment_list");
    const locations = document.getElementById("location_list");
    const doctors = document.getElementById("doctor_list");
    const users = document.getElementById("user_list");
    const status = document.getElementById("status_list");
    const types = document.getElementById("type_list");
    const mops = document.getElementById("mop_list");

    if (segments) { newParams.push({value: 0, label: "Segment", data1: segments.textContent || "" }); }
    if (locations) { newParams.push({value: 0, label: "Location", data1: locations.textContent || "", }); }
    if (doctors) { newParams.push({value: 0, label: "Doctor", data1: doctors.textContent || "", }); }
    if (users) { newParams.push({value: 0, label: "Dispenser", data1: users.textContent || "", }); }
    if (status) { newParams.push({value: 0, label: "Status", data1: status.textContent || "", }); }
    if (types) { newParams.push({value: 0, label: "Type", data1: types.textContent || "", }); }
    if (mops) { newParams.push({value: 0, label: "Mode of pay", data1: mops.textContent || "", }); }

    setParamInfo(newParams);
  };

  const generateParamHtml = (paramInfo: OptionMore[]): (JSX.Element | null)[] => {
    return paramInfo.map((param, index) =>
      param.data1 !== "Select" ? (
        <div className="report-param" key={index}>
          <b>{param.label}:</b> {param.data1}
        </div>
      ) : null
    );
  };


  const totalSummary = reportColumnData.map((column, colIndex) => {
    const key = `data${colIndex + 1}`;

    if (column.summary === Code.Option.ColumnSummary.COUNT.toString()) {
      const count = reportData.filter(row => {
        const val = (row as any)[key];
        return val !== null && val !== undefined && val !== "";
      }).length;
      return `Nos: ${count}`;
    }

    const values = reportData.map(row => {
      const val = parseFloat((row as any)[key]);
      return isNaN(val) ? null : val;
    }).filter(val => val !== null) as number[];

    switch (column.summary) {
      case Code.Option.ColumnSummary.SUM.toString(): 
        return values.reduce((a, b) => a + b, 0).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).replace(".00","");

      case Code.Option.ColumnSummary.TIME_SUM.toString():

        const timeValues = reportData
            .map(row => (row as any)[key]?.toString())
            .filter(v => v);

        return sumTimes(timeValues);

      case Code.Option.ColumnSummary.AVERAGE.toString(): 
        if (values.length === 0) return "";
        const avg = values.reduce((a, b) => a + b, 0) / values.length;
        return `Avg: ${avg.toFixed(2)}`;

      case Code.Option.ColumnSummary.MAXIMUM.toString():
        return `Max: ${values.length > 0 ? Math.max(...values).toFixed(2) : ''}`;

      case Code.Option.ColumnSummary.MINIMUM.toString():
        return `Max: ${values.length > 0 ? Math.min(...values).toFixed(2) : ''}`;

      default:
        return "";
    }
  });

  function sumTimes(values: string[]): string {
      let totalMinutes = 0;

      values.forEach(time => {
          if (!time) return;

          const [hours, minutes] = time.toString().split(":");
          console.log(hours, minutes);
          totalMinutes += (parseInt(hours) || 0) * 60;
          totalMinutes += parseInt(minutes || "0");
      });

      console.log("totalMinutes:",totalMinutes);

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      console.log("hours::minutes::",hours, minutes);

      return `${hours}:${minutes.toString().padStart(2, "0")}`;
  }

  const subSummaryValues = (headValue: string | undefined) =>
    reportColumnData.map((column, colIndex) => {
      if (!headValue) return "";

      const key = `data${colIndex + 1}`;
      const filteredRows = reportData.filter(row => row.head?.trim() === headValue.trim());

      if (column.summary === Code.Option.ColumnSummary.COUNT.toString()) {
        const count = filteredRows.filter(row => {
          const val = (row as any)[key];
          return val !== null && val !== undefined && val !== "";
        }).length;
        return `Nos: ${count}`;
      }

      const values = filteredRows
        .map(row => {
          const val = parseFloat((row as any)[key]);
          return isNaN(val) ? null : val;
        })
        .filter(val => val !== null) as number[];

      switch (column.summary) {
        case Code.Option.ColumnSummary.SUM.toString():
          return values
            .reduce((a, b) => a + b, 0)
            .toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).replace(".00","");

        case Code.Option.ColumnSummary.TIME_SUM.toString():

          const timeValues = filteredRows
            .map(row => (row as any)[key])
            .filter(v => v !== null && v !== undefined && v !== "")
            .map(v => v.toString());

          return sumTimes(timeValues);

        case Code.Option.ColumnSummary.AVERAGE.toString():
          if (values.length === 0) return "";
          const avg = values.reduce((a, b) => a + b, 0) / values.length;
          return `Avg: ${avg.toFixed(2)}`;

        case Code.Option.ColumnSummary.MAXIMUM.toString():
          return `Max: ${values.length > 0 ? Math.max(...values).toFixed(2) : ""}`;

        case Code.Option.ColumnSummary.MINIMUM.toString():
          return `Min: ${values.length > 0 ? Math.min(...values).toFixed(2) : ""}`;

        default:
          return "";
      }
    });

  const grouped = reportData.reduce((acc, row) => {
    const key = row.head?.trim() ?? 'Unknown';
    if (!acc[key]) acc[key] = [];
    acc[key].push(row);
    return acc;
  }, {} as Record<string, ReportData[]>);

  const onClearFilter = () =>{
    setSelectedLocation([]);
    setSelectedBranch([]);
    setSelectedSegment([]);
    setSelectedDoctor([]);
    setSelectedUser([]);
    setSelectedStatus([]);
    setSelectedType([]);
    setSelectedExamType([]);
  }

  useEffect(() => {
    console.log("chartData:>",chartData)
  }, [chartData]);

  function updateReportFilter(
    prev: ReportFilter,
    fieldName: string,
    value: string
  ): ReportFilter {
    const updated = { ...prev };

    for (let i = 1; i <= 9; i++) {
      const fieldKey = `field${i}` as keyof ReportFilter;
      const valueKey = `value${i}` as keyof ReportFilter;

      if (prev[fieldKey] == fieldName || !prev[valueKey]) {
        updated[fieldKey] = fieldName;
        updated[valueKey] = value;
        break;
      }
    }
    return updated;
  }

  const getChartData = () => {
    
    if(reportData && reportColumnData && reportData.length>0 && reportColumnData.length>0)
    {
      console.log("reportData:>",reportData);
      if(selectedView == Code.Option.DataView.LIST)
      {
        const labels = reportData.map(row => row.data1).filter((v): v is string => typeof v === 'string');
        const datasets = reportColumnData
          .map((column, colIndex) => ({ ...column, colIndex })) // preserve original index
          .filter(column => column.id === Code.Option.ColumnType.AMOUNT.toString())
          .map(column => {
            const key = `data${column.colIndex + 1}` as keyof ReportData;
            return {
              label: column.title,
              data: reportData.map(row => Number(row[key] ?? 0)),
            };
          });
        const chartData = { labels: labels, datasets: datasets, };
        setChartData(chartData);
      } else {
       
        const chartData = Object.entries(grouped).reduce(
          (acc, [head, _rows]) => {
            const subSummary = subSummaryValues(head);
            acc.labels.push(head);

            reportColumnData
              .map((column, colIndex) => ({ ...column, colIndex }))
              .filter(column => column.id === Code.Option.ColumnType.AMOUNT.toString())
              .forEach(column => {
                const title = column.title;
                if (!title) return;

                const val = Number(subSummary[column.colIndex] ?? 0);

                if (!acc.datasetMap[title]) {
                  acc.datasetMap[title] = [];
                }

                acc.datasetMap[title].push(val);
              });

            return acc;
          },
          {
            labels: [] as string[],
            datasetMap: {} as Record<string, number[]>,
          }
        );

        // Convert datasetMap to Chart.js dataset format
        const datasets = Object.entries(chartData.datasetMap).map(([title, data]) => ({
          label: title,
          data,
        }));

        setChartData({
          labels: chartData.labels,
          datasets,
        });
        
      }
      
      const chartOption = {
        responsive: true,
        plugins: {
          legend: { position: "top" as const },
          title: { display: true, text: formData.report_name },
        },
      };
      setChartOption(chartOption);
    }
  }

  // getSelectedLabel()
  // {
  //   let selectedItemLabels = selectedItems
  //   .map(itemValue => AllItemList.find(item => item.value.toString() === itemValue)?.label)
  //   .join(", ");
  // }

  return (
    <>
      <Control.Report.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
        <div className="report-panel">
          <div className="report-tool">
            <div className="report-right">
              <div className="report-heading">REPORTS</div>
              <Messages.Toast Messages={message} Error={error} />
            </div>
            <div className="report-left">
                <div className='report-list'>
                  <Field.FilterSelect id={Name.Report.Id} value={reportId} options={reportList} setSelectedId={setReportId} />
                </div>
                <div className='report-session'>
                  <Field.FilterSelect id={Name.Report.Session} value={sessionId} options={sessionOptions} setSelectedId={setSessionId} />
                </div>
                {dateVisible && (<>
                    <div className='report-date'>
                      <Field.Date id={Name.Report.StartDate} value={new Date(startDate + 'T10:00:00')} onChange={(e) => setStartDate(e.target.value)} />
                    </div>
                    <div className='report-date rdr'>
                      <Field.Date id={Name.Invoice.EndDate} value={new Date(endDate + 'T10:00:00')} onChange={(e) => setEndDate(e.target.value)} />
                    </div>
                </>)}
                <div className='report-options'>
                  <Button.Icon onClick={() => { setShowFilter(!showFilter)}} className='bfilter filter fsetting' animation={false} info='Show custom Filters' />
                  <Button.Icon onClick={() => { setShowLayout(!showlayout)}} className='bfilter filter flayout' animation={false} info='Show custom formats' />
                  <Button.Action title={"Show"} onClick={() => onShowReport()} className='mr2' />
                  <Button.Icon onClick={window.print} className='bprint' animation={false} info='Print Preview (Alt+P)' />
                </div>
            </div>
          </div>
        </div>
        <div className="report-data" ref={printRef}>
          <div className={`report-orientation ${Utility.Class.Orientation(selectedOrientation)}`}>
            {selectedChart != Code.Option.Common.NONE && chartOption && chartData && (
              <div className='report-chart'>
                <ChartDesigner type={selectedChart} option={chartOption} data={chartData} />
              </div>
            )}
            {showReport && (<>
              <div className={`report-top`}>
                  <div className="report-self">
                      <div className="report-company">{companyName}</div>
                  </div>
                  <div className="report-desc">
                      <div className="report-name">{formData.report_name}</div>
                      <div className="report-param"><b>Generated on:</b>{Utility.Format.DateTime(new Date())}</div>
                      {generateParamHtml(paramInfo)}
                      <div className="report-param"><b>From:</b>{startDate}</div>
                      <div className="report-param"><b>To:</b>{endDate}</div>
                  </div>
              </div>
              <div className="report-wrapper">
                <table className='report-table'>
                  <tr className="report-title">
                    {formData.report_sno && formData.report_sno === Code.Option.Active.YES && (
                      <td className="rsno">#</td>
                    )}
                    {reportColumnData.map((column, colIndex) => { return (
                      <td className={`rdata${colIndex} align${column.align}`}><div>{column.title}</div></td>
                    )})}
                  </tr>

                  { selectedView == Code.Option.DataView.LIST ? (
                   // Flat Mode
                    reportData.map((row, rowIndex) => (
                      <tr className="report-row" key={rowIndex}>
                        {formData.report_sno && formData.report_sno === Code.Option.Active.YES && (
                          <td className="rsno copy">
                            <div>{rowIndex + 1}</div>
                          </td>
                        )}
                        {reportColumnData.map((column, colIndex) => (
                          <td key={colIndex} onClick={() => (row as any)[`link`] && Form.Show.Popup(iframeRef, (row as any)[`link`])}>
                            <div className={`rdata${colIndex} copy align${column.align}`}>
                              {`${column.prefix ? `${column.prefix}` : column.id == Code.Option.ColumnType.AMOUNT ? '$' :''}${(row as any)[`data${colIndex + 1}`]}${column.postfix ? ` ${column.postfix}`:''}`}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))
                  ): null}

                  { selectedView == Code.Option.DataView.GROUP ? (
                      // Grouped Mode
                      Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b)).map(([head, rows]) => {
                        const subSummary = subSummaryValues(head);
                        return (
                          <React.Fragment key={head}>
                            <tr>
                              <td className="report-group" colSpan={reportColumnData.length}>
                                <div>
                                  {head.toUpperCase()}
                                </div>
                              </td>
                            </tr>
                            {rows.map((row, rowIndex) => (
                              <tr className="report-row" key={rowIndex}>
                                {formData.report_sno && formData.report_sno === Code.Option.Active.YES && (
                                  <td className="rsno copy">
                                    <div>{rowIndex + 1}</div>
                                  </td>
                                )}
                                {reportColumnData.map((column, colIndex) => (
                                  <td key={colIndex} onClick={() => (row as any)[`link`] && Form.Show.Popup(iframeRef, (row as any)[`link`])}>
                                    <div className={`rdata${colIndex} copy align${column.align}`}>
                                      {`${column.prefix ? `${column.prefix}` : column.id == Code.Option.ColumnType.AMOUNT ? '$' :''}${(row as any)[`data${colIndex + 1}`]}${column.postfix ? ` ${column.postfix}`:''}`}
                                    </div>
                                  </td>
                                ))}
                              </tr>
                              
                            ))}
                            <tr className="report-sub br0 mb2">
                              {formData.report_sno && formData.report_sno === Code.Option.Active.YES && (
                                <td className="rsno"><div>{reportData.filter((item) => item.head === head).length}</div></td>
                              )}
                              {reportColumnData.map((column, colIndex) => { return (
                                <td className={`rdata${colIndex} copy align${column.align}`}>
                                  <div>
                                    {`${column.prefix ?? (column.id === Code.Option.ColumnType.AMOUNT ? '$' : '')}${subSummary[colIndex] ?? ''}${column.postfix ? ` ${column.postfix}` : ''}`}
                                  </div>
                                </td>
                              )})}
                            </tr>
                          </React.Fragment>
                        );
                      })
                  ): null}

                  { selectedView == Code.Option.DataView.SUMMARY ? (
                      // Grouped Mode
                      Object.entries(grouped).map(([head, rows]) => {
                        const subSummary = subSummaryValues(head);
                        return (
                          <React.Fragment key={head}>
                            <tr className="report-sub fwn">
                              <td className='rdata0'>
                                <div>{head}</div>
                              </td>
                              {reportColumnData.slice(1).map((column, colIndex) => { return (
                                <td className={`rdata${colIndex+1} copy align${column.align}`}>
                                  <div>
                                    {`${column.prefix ?? (column.id === Code.Option.ColumnType.AMOUNT ? '$' : '')}${subSummary[colIndex+1] ?? ''}${column.postfix ? ` ${column.postfix}` : ''}`}
                                  </div>
                                </td>
                              )})}
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : null}

                  <tr className="report-total">
                    {formData.report_sno && formData.report_sno === Code.Option.Active.YES && (
                      <td className="rsno"><div>{reportData.length}</div></td>
                    )}
                    {reportColumnData.map((column, colIndex) => { return (
                      <td className={`rdata${colIndex} copy align${column.align}`}>
                        <div>
                          {`${column.prefix ? `${column.prefix}` : column.id == Code.Option.ColumnType.AMOUNT ? '$' :''}${totalSummary[colIndex]}${column.postfix ? ` ${column.postfix}`:''}`}
                        </div>
                      </td>
                    )})}
                  </tr>
                  
                  {formData.report_note && (
                    <tr className='report-footer'>
                      <td colSpan={reportColumnData.length}>
                        <div>
                          {formData.report_note}
                        </div>
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </>)}
            {formData.report_style && (<style>{formData.report_style}</style>)}
            {(showFilter || showlayout) && (
              <div className='report-filter-wrapper'>
                { showFilter && (
                  <div className='report-filter'>
                    <div className='report-filter-title'>
                      <span>Custom Filters</span>
                      <a className="report-filter-close" onClick={() => setShowFilter(false)}>×</a>
                    </div>
                    <div className='report-filter-body'>
                      { locationMap.includes(reportTable) && (<Field.MultiSelect title="Location" id={"location"} options={locationOptions} selectedItems={selectedLocation} setSelectedItems={setSelectedLocation}/>  )}
                      { branchMap.includes(reportTable) && (<Field.MultiSelect title="Branch" id={"branch"} options={locationOptions} selectedItems={selectedBranch} setSelectedItems={setSelectedBranch}/> )}
                      { segmentMap.includes(reportTable) && (<Field.MultiSelect title="Segment" id={"segment"} options={segmentOptions} selectedItems={selectedSegment} setSelectedItems={setSelectedSegment}/> )}
                      { doctorMap.includes(reportTable) && (<Field.MultiSelect title="Doctor" id={"doctor"} options={doctorOptions} selectedItems={selectedDoctor} setSelectedItems={setSelectedDoctor}/> )}
                      { userMap.includes(reportTable) && (<Field.MultiSelect title="Dispenser" id={"user"} options={userOptions} selectedItems={selectedUser} setSelectedItems={setSelectedUser}/> )}
                      { statusMap.includes(reportTable) && (<Field.MultiSelect title="Status" id={"status"} options={statusOptions} selectedItems={selectedStatus} setSelectedItems={setSelectedStatus}/> )}
                      { typeMap.includes(reportTable) && (<Field.MultiSelect title="Type" id={"type"} options={typeOptions} selectedItems={selectedType} setSelectedItems={setSelectedType}/> )}
                      { mopMap.includes(reportTable) && (<Field.MultiSelect title="Mode of pay" id={"mop"} options={mopOptions} selectedItems={selectedMop} setSelectedItems={setSelectedMop}/> )}
                      { examTypeMap.includes(reportTable) && (<Field.MultiSelect title="Type" id={"examtype"} options={examTypeOptions} selectedItems={selectedExamType} setSelectedItems={setSelectedExamType}/> )}
                      <Button.Action title={"Clear"} onClick={() => onClearFilter()} className='mt2 mr2' animation={false} />
                    </div>
                  </div>
                )}
                
                { showlayout && (
                  <div className='report-filter'>
                    <div className='report-filter-title'>
                      <span>Custom Layout</span>
                      <a className="report-filter-close" onClick={() => setShowLayout(false)}>×</a>
                    </div>
                    <div className='report-filter-body'>
                        <Field.Select id={"charttype"} title='Chart' value={selectedChart} options={chartOptions} onChange={(e) => setSelectedChart(Form.Field.Value(e))} />
                        <Field.Select id={"orientation"} title='Page' value={selectedOrientation} options={orientationOptions} onChange={(e) => setSelectedOrientation(Form.Field.Value(e))} />
                        <Field.Select id={"view"} title='Format' value={selectedView} options={viewOptions} onChange={(e) => setSelectedView(Form.Field.Value(e))} />
                    </div>
                    </div>
                ) }
              </div>
            )}

          </div>

        </div>

        <Control.Report.Info>
          <Control.Report.Rows dataLength={reportData.length} />
        </Control.Report.Info>

      </Control.Report.Frame>
      {showMenu && (<div ref={contextMenuRef}><Control.ReportContextMenu showMenu={showMenu} formName={formName} showFilter={showFilter} setShowFilter={setShowFilter}  setShowMenu={setShowMenu} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={() => onShowReport()} />
      <Actions.Report />
    </>
  );
};

export default ReportCustom;